<div class="profile-container">
  <h2 class="page-header">User Profile</h2>

  <div *ngIf="isLoading" class="loading-container">
    <p>Loading profile...</p>
  </div>

  <div *ngIf="error" class="error-container">
    <p class="error-message">{{ error }}</p>
    <button (click)="loadProfile()" class="retry-button">Retry</button>
  </div>

  <div *ngIf="profileData && !isLoading && !error" class="profile-content">
    <div class="profile-card">
      <!-- Business Details Section -->
      <div class="profile-section">
        <div class="section-heading">Business Details</div>
        <div class="section-content">
          <div class="detail-row">
            <span class="detail-label">Business Name</span>
            <span class="detail-value">{{ profileData.merchantName || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Registered Contact</span>
            <span class="detail-value">{{ profileData.merchantContactNumber || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Registered Email</span>
            <span class="detail-value">{{ profileData.companyEmail || profileData.registeredEmail || profileData.emailId
              || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Merchant ID</span>
            <span class="detail-value">{{ profileData.merchantId ||  'N/A' }}</span>
          </div>
        </div>
      </div>

      <!-- Separator -->
      <div class="section-separator"></div>

      <!-- Personal Details Section -->
      <div class="profile-section">
        <div class="section-heading">Personal Details</div>
        <div class="section-content">
          <div class="detail-row">
            <span class="detail-label">Full Name</span>
            <span class="detail-value">{{ profileData.fullName || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Email</span>
            <span class="detail-value">{{ profileData.emailId || 'N/A' }}</span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Phone Number</span>
            <span class="detail-value">{{ profileData.phoneNumber || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Password</span>
            <span class="detail-value">
              <span class="password-mask">************</span>
              <span class="edit-link" (click)="editPassword()">Change</span>
            </span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Role</span>
            <span class="detail-value">{{ getRole(profileData.roleName)  }}</span>
          </div>
        </div>
      </div>
      <br>
      <br>
      <hr>
      <!-- Login Details Section -->
      <div class="profile-section">
        <div class="section-header"><span>Secure login</span></div>
        <div class="details-grid">
          <div class="detail-row">
            <div class="dropdown-card" (click)="toggleDropdown()">
              <div class="selected">
                {{ selectedOption }}
                <span class="arrow" [class.open]="isOpen">&#9662;</span>
              </div>

              <div class="options" *ngIf="isOpen">
                <div class="option" (click)="selectOption('OTP', $event)">Email OTP</div>
                <div class="option" (click)="selectOption('TFA', $event)">TOTP</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>